export default __webpack_public_path__ + "static/media/icon-map.68ecbb16.svg";